<template>
  <div>
    <div v-if="itsBitsems">
      <BitsEMS></BitsEMS>
    </div>
    <div v-else>
      <WebsiteHeader></WebsiteHeader>
      <v-main class="pt-0">
        <home :school="getUserSchool" />
        <!-- <about :school="getUserSchool"/> -->
        <download :school="getUserSchool" />
        <pricing :stats="getSiteStats" />
        <contact :school="getUserSchool" />
      </v-main>
      <v-scale-transition>
        <v-btn
          fab
          v-show="fab"
          v-scroll="onScroll"
          dark
          fixed
          bottom
          right
          :color="getThemeColor"
          @click="toTop"
        >
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
      </v-scale-transition>
      <TemplateFooter :color="getThemeColor" :school="getUserSchool" />
    </div>
    <Loader></Loader>
  </div>
</template>

<style scoped>
.v-main {
  background-image: url("~@/assets/img/bgMain.png");
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}
</style>

<script>
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import TemplateFooter from "./Footer";
import home from "./HomeSection";
//import about from "./AboutSection";
import download from "./DownloadSection";
import pricing from "./PricingSection";
import contact from "./ContactSection";
import BitsEMS from "@/components/SchoolWebsite/BitsEMS.vue";
import Loader from "@/components/Loader.vue";

export default {
  name: "App",

  components: {
    BitsEMS,
    WebsiteHeader,
    TemplateFooter,
    home,
    // about,
    download,
    pricing,
    contact,
    Loader,
  },

  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },

    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getFrontPageImages() {
      return this.$store.getters.getFrontPageImages;
    },
    itsBitsems() {
      return this.$store.getters.itsBitsems;
    },
    getSiteStats() {
      return this.$store.getters.getSiteStats;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    enableEditing() {
      return this.$store.getters.enableEditing;
    },
    features() {
      return [
        {
          icon: "mdi-shield-outline",
          title: "Our Motto",
          text: this.getUserSchool.motto,
        },
        {
          icon: "mdi-update",
          title: "Our Vision",
          text: this.getUserSchool.vision,
        },
        {
          icon: "mdi-account-group-outline",
          title: "Our Misiion",
          text: this.getUserSchool.mission,
        },
      ];
    },
  },

  data: () => ({
    fab: null,
    color: "",
    flat: null,
    menu: [
      {
        icon: "mdi-home",
        title: "Home",
        description: "",
        color: "deep-orange darken-4",
        route: "school-website",
        buttonText: "Enter",
        alevel: 1,
        param: "",
      },

      {
        icon: "apps",
        title: "Switchboard",
        description: "",
        color: "deep-orange darken-4",
        route: "switchboard",
        buttonText: "Enter",
        alevel: 1,
        param: "",
      },
      {
        icon: "mdi-play-box-multiple",
        title: "Gallery",
        description: "",
        color: "deep-orange darken-4",
        route: "images-gallery",
        buttonText: "Enter",
        alevel: 1,
        param: "",
      },
      {
        icon: "assignment_ind",
        title: "Sign In",
        description: "",
        color: "deep-orange darken-4",
        route: "login",
        buttonText: "Enter",
        alevel: 1,
        param: "",
      },
      {
        icon: "person_add",
        title: "Create Account",
        description: "",
        color: "deep-orange darken-4",
        route: "register",
        buttonText: "Enter",
        alevel: 1,
        param: "",
      },
    ],
  }),

  created() {
    if (
      window.location.hostname.includes("172") ||
      window.location.hostname.includes("bitsems.co.za")
    ) {
      this.$store.commit("setItsBitsems", true);
    }
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "transparent";
      this.flat = true;
    }
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = "secondary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },

  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>
